var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"disabled":_vm.disable,"type":_vm.type || 'primary',"size":_vm.size || 'large'},on:{"click":_vm.clickBtn}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }